module.exports = new __parcel__URL__("mining_divider.9ccb48df.png").toString();